<template>
  <h2>Edit id {{$route.params.id}}</h2>
</template>

<script>
export default {
  
}
</script>



// WEBPACK FOOTER //
// src/components/Edit.vue